import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types'
import formValidators from '../../../../utils/validation/formValidators'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import fullstory from '../../../../utils/constants/fullstory'

/**
 * @class StudentInvitationForm
 * @description Form that manages creating an invitation for a Student
 */
class StudentInvitationForm extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  /**
   * @method render
   */
  render() {
    const { onSubmit, invalid, onClose } = this.props

    return (
      <div style={{ position: 'relative' }}>
        <i
          className="fal fa-times"
          style={{ position: 'absolute', right: 0, top: -30, fontSize: 20, cursor: 'pointer' }}
          onClick={() => onClose()}
        />
        <div style={{ marginTop: 10 }}>
          <Field
            className={fullstory.classNames.textInput}
            name="student_email"
            component={renderTextInputWithFeedback}
            placeholder="New Student Email"
          />
          <button className="btn btn-primary btn-block" onClick={onSubmit} disabled={invalid}>
            Invite
          </button>
        </div>
      </div>
    )
  }
}

// Form validation function run by redux-form
const validate = values => {
  const errors = {}
  errors.student_email = formValidators.isAnEmail(values.student_email)
  return errors
}

/**
 * @description Decorated form (connected to redux)
 */
export default reduxForm({
  form: 'studentInvitationForm',
  validate,
})(StudentInvitationForm)



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/StudentInvitationForm.js